import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/style.css';
import '../styles/mediaqueries.css';

export default function Footer() {
    const location  = useLocation();
    const navigate  = useNavigate();
    const isLanding = location.pathname === '/';

    const handleNav = (href, e) => {
        e.preventDefault();

        if (href.startsWith('#')) {
            // Scroll to section and update URL hash
            const target = document.querySelector(href);
            if (target) target.scrollIntoView({ behavior: 'smooth' });
            window.history.replaceState(null, '', href);
            return;
        }

        navigate(href);
    };

    const handleLogo = () => {
        if (isLanding) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            window.history.replaceState(null, '', '/');
        } else {
            navigate('/');
        }
    };

    const links = isLanding
        ? [
            { label: 'About',    href: '#about'      },
            { label: 'Skills',   href: '#experience' },
            { label: 'Projects', href: '#projects'   },
            { label: 'Contact',  href: '#contact'    },
        ]
        : [
            { label: 'Home',         href: '/'         },
            { label: 'All Projects', href: '/projects' },
            { label: 'Contact',      href: '#contact'  },
        ];

    return (
        <footer>
            <div
                className="logo"
                onClick={handleLogo}
                style={{ cursor: 'pointer' }}
                title={isLanding ? 'Back to top' : 'Go home'}
            >
                SW<span className="logo-dot">.</span>
            </div>

            <nav>
                <ul className="nav-links">
                    {links.map(({ label, href }) => (
                        <li key={href}>
                            <a href={href} onClick={e => handleNav(href, e)}>{label}</a>
                        </li>
                    ))}
                </ul>
            </nav>

            <p>Copyright © {new Date().getFullYear()} Waithaka Sam Technologies. All Rights Reserved.</p>
        </footer>
    );
}